import React from "react";
import EditTemplate from "@/partial/template/edit-template";

const EditTemplatePage: React.FC = () => {
  return <EditTemplate />;
};

export default EditTemplatePage;
